import Parchment from 'parchment';
import Quill from 'quill/core/quill';

import { BlockEmbed } from 'quill/blots/block';
import Blockquote from 'quill/formats/blockquote';
import Break from 'quill/blots/break';
import Container from 'quill/blots/container';
import Cursor from 'quill/blots/cursor';
import Embed from 'quill/blots/embed';
import Inline from 'quill/blots/inline';
import Scroll from 'quill/blots/scroll';
import TextBlot from 'quill/blots/text';

import Bold from 'quill/formats/bold';
import Italic from 'quill/formats/italic';
import Link from 'quill/formats/link';
import Underline from 'quill/formats/underline';

import Clipboard from 'quill/modules/clipboard';
import History from 'quill/modules/history';
import Keyboard from 'quill/modules/keyboard';
import Toolbar from 'quill/modules/toolbar';

import DiscoveryTheme from './themes/discovery';

import IndentedBlockBlot from './blots/indented-block-blot';
import MentionBlot from './blots/mention-blot';

import MentionModule from './modules/mention';

Quill.register({
  'blots/block'        : IndentedBlockBlot,

  'blots/block/embed'  : BlockEmbed,
  'blots/break'        : Break,
  'blots/container'    : Container,
  'blots/cursor'       : Cursor,
  'blots/embed'        : Embed,
  'blots/inline'       : Inline,
  'blots/scroll'       : Scroll,
  'blots/text'         : TextBlot,

  'blots/mention'      : MentionBlot,

  'formats/blockquote': Blockquote,
  'formats/bold': Bold,
  'formats/italic': Italic,
  'formats/link': Link,
  'formats/underline': Underline,

  'modules/clipboard'  : Clipboard,
  'modules/history'    : History,
  'modules/keyboard'   : Keyboard,
  'modules/toolbar'    : Toolbar,


  'modules/mention'    : MentionModule,

  'themes/discovery'   : DiscoveryTheme,
});

Parchment.register(IndentedBlockBlot, Break, Cursor, Inline, Scroll, TextBlot, MentionBlot);


export default Quill;
